const SentimentBar = ({ sentiment }) => {
  return (
    <div className="sentiment-bar" style={{ borderLeftColor: sentiment.color }}>
      <span className="sentiment-emoji">{sentiment.emoji}</span>
      <span className="sentiment-text">
        <strong>{sentiment.level}</strong> - {sentiment.message}
      </span>
    </div>
  );
};

export default SentimentBar;
